// 2026-10-18：缺少路由键时只翻译已知界面标题，避免展示原始键。
import i18n from '@/i18n'
import {translateUi} from '@/i18n/display'
export const generateTitle = (title: any, fallbackTitle?: any): string => {
  const key='msg.route.'+String(title || '')
  return i18n.global.te(key) ? i18n.global.t(key) : translateUi(fallbackTitle || title || '')
}
